<template>
  <div
    class="more-menu-item"
    :title="$getText('GO_TO', { goto: menuItem.name })"
    :data-selected="isSelected"
    v-on="$listeners"
  >
    <span class="sr-only">{{ $getText('NAVIGATE_TO') }}{{ menuItem.name.toLowerCase() }}</span>
    <span aria-hidden="true">
      <badge-notification v-if="badgeCount > 0" :amount="badgeCount" :border="true" />
      <img v-if="isImage" class="menu-icon" :src="menuIconImageSource" :alt="menuItem.name" />
      <i v-else class="menu-icon" :class="menuIconImageSource" />
      <span class="more-menu-text" :class="{ 'widget-text': isWidget }">{{ menuTitle }}</span>
    </span>
  </div>
</template>
<script>
import BadgeNotification from '../../components/BadgeNotification.vue';
import { institutionRole } from '../../enums/institutionRole';
import { menuUtil } from '../../utils/menuUtil';
import { useUserProfileStore } from '../../stores';

export default {
  components: {
    BadgeNotification,
  },
  props: {
    menuItem: {
      required: true,
      type: Object,
    },
    badgeCount: {
      default: () => 0,
      required: false,
      type: Number,
    },
  },
  computed: {
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    isSelected() {
      let path = this.menuItem.url;
      if (this.menuItem.widgetId) {
        path = '/widgets/W' + this.menuItem.widgetId + 'V' + this.menuItem.widgetVersion;
      }

      return Boolean(this.$route.path.match(`^${path}`));
    },
    menuTitle() {
      const menuTextKey = menuUtil.getMenuType(this.menuItem.type);
      if (menuTextKey) {
        return this.$getText(menuTextKey);
      }
      return this.menuItem.name;
    },
    isImage() {
      return menuUtil.getIsIconImage(this.menuIconImageSource);
    },
    isChild() {
      return this.userProfileStore.institutionRoles.includes(institutionRole.EARLY_STUDENT);
    },
    isWidget() {
      return this.menuItem.widgetId != null;
    },
    menuIconImageSource() {
      if (this.isChild && !this.isWidget) {
        return 'static/icons/' + this.menuItem.icon + '_child.svg';
      }
      if (this.isWidget && !this.menuItem.icon) {
        return 'icon-Aula_widget';
      }
      if (this.isSelected && this.menuItem.iconHover?.length > 0) {
        return this.menuItem.iconHover;
      }
      return menuUtil.getMenuIconClass(this.menuItem);
    },
  },
};
</script>
<style scoped lang="scss">
.more-menu-item {
  --aula-badge-box-shadow-color: var(--color-grey-dark);
  &:hover {
    --aula-badge-box-shadow-color: var(--color-grey-dunkel);
  }
  &[data-selected='true'] {
    --aula-badge-box-shadow-color: var(--color-primary-darker);
  }
}
</style>
